
import axios from "../utils/axios";

function request(functionId, body) {
  let data = {
    functionId,
    body
  };
  return axios.request({
    data: data,
    method: "post"
  });
}

// 分页查询敏感词列表
export function manPageContentSensitiveWo(body) {
  return request('health_cmp_biz_manPageContentSensitiveWo', body);
}
// 上传敏感词
export function manImportContentSensitive(body) {
  return request('health_cmp_biz_importExcel', body);
}
// 下载敏感词
export function manExportContentSensitive(body) {
  return request('health_cmp_biz_exportExcel', body);
}
// 删除敏感词
export function manUpdateContentSensitive(body) {
  return request('health_cmp_biz_manUpdateContentSensitive', body);
}

// 删除敏感词
export function queryDictionaries(body) {
  return request('health_cmp_queryDictionaries', body);
}
